module.exports = __webpack_public_path__ + "static/media/planet-level13.3bc107b0.png";